/** Troca o item de `index` com o vizinho em `delta`; devolve a mesma lista se sair dos limites. */
export const moveItem = <T>(list: T[], index: number, delta: -1 | 1): T[] => {
  const target = index + delta;
  if (index < 0 || index >= list.length || target < 0 || target >= list.length) return list;
  const copy = [...list];
  [copy[index], copy[target]] = [copy[target], copy[index]];
  return copy;
};
